import React from 'react';
import { T as Typography } from './Typography-BUVIUAC9.js';

function Emphasis({ variation, children }) {
    const variationMap = {
        bold: { element: "b", fontWeight: "bold" },
        italic: { element: "em", emphasisType: "italic" },
        highlight: { element: "strong", emphasisType: "highlight" },
    };
    return React.createElement(Typography, Object.assign({}, variationMap[variation]), children);
}

export { Emphasis as E };
